import React, { useState } from 'react';
import { MdOutlineSecurity } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { Box, Button, Flex, Heading, Text, useToast } from '@chakra-ui/react';
import { initiateTotp } from 'api/mfa';
import { useAuthentication } from 'AuthContext';
import { MFA_SETUP_ROUTE } from 'constants/routes';
import { showError } from 'utils/notifications';

const MfaSettings = () => {
  const history = useHistory();
  const toast = useToast();
  const { user } = useAuthentication();
  const [loading, setLoading] = useState(false);

  const handleEnableMFA = async () => {
    try {
      setLoading(true);
      const response = await initiateTotp();
      const { qr_code, totp_secret, token } = response.data.data;

      setLoading(false);

      history.push({
        pathname: MFA_SETUP_ROUTE,
        state: {
          qrCode: qr_code,
          totpSecret: totp_secret,
          token,
        },
      });
    } catch (error) {
      setLoading(false);
      showError(toast, 'Failed to initiate MFA setup', error, 'Unable to start MFA setup. Please try again.');
    }
  };

  const isMfaEnabled = user?.is_mfa_enabled;

  return (
    <Box p={6}>
      <Heading size='lg' mb={6}>
        Security
      </Heading>

      <Flex align='center' justify='space-between' p={4} borderWidth={1} borderRadius='md' borderColor='gray.200'>
        <Flex align='center'>
          <Box as={MdOutlineSecurity} size='36px' color='blue.500' mr={4} />
          <Box>
            <Text fontSize='lg' fontWeight='medium' mb={1}>
              2 Factor Authentication
            </Text>
            {!isMfaEnabled && (
              <Text fontSize='sm' color='gray.600'>
                Add an extra layer of protection used to ensure the security of online accounts
              </Text>
            )}
          </Box>
        </Flex>

        {!isMfaEnabled ? (
          <Button colorScheme='blue' onClick={handleEnableMFA} isLoading={loading} size='md'>
            Enable
          </Button>
        ) : (
          <Text fontSize='md' fontWeight='medium' color='green.500'>
            Enabled
          </Text>
        )}
      </Flex>
    </Box>
  );
};

export default MfaSettings;
